import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";

const state = {
  errors: 0,
  user: {
    Token: null,
    account: {},
    ubigeo: [],
    tpodocs: [],
    marital_status: [],
    blood_type: [],
    phone_type: [],
    occupations: [],
    menu: []
  },
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  account(state) {
    return state.user.account;
  },
  tpodocs(state){
    return state.user.tpodocs;
  },
  oficialType(state){
    return state.user.oficial_type;
  },
  maritalStatus(state) {
    return state.user.marital_status
  },
  bloodType(state) {
    return state.user.blood_type
  },
  phoneType(state) {
    return state.user.phone_type
  },
  occupations(state) {
    return state.user.occupations
  },
  menu(state){
    return state.user.menu
  },
  danes(state){
    return state.user.danes
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  async [LOGIN](context, credentials) {
    return await new Promise(function(resolve, reject){
      ApiService.notHeader();
      ApiService.post("/auth/login", credentials)
      .then(({ data }) => {
        context.commit(SET_AUTH, data);
        resolve(data);
      })
      .catch(({ response }) => {
        context.commit(SET_ERROR, response.data);
        reject(response.data);
      });
    })
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("login", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  async [VERIFY_AUTH](context) {
    if (JwtService.getToken() != 'undefined') {
      return await new Promise(function(resolve, reject){
        ApiService.setHeader();
        ApiService.post("api/account/setting")
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response);
          reject(response);
        });
      })
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_PASSWORD](context, payload) {
    const password = payload;

    return ApiService.put("password", password).then(({ data }) => {
      context.commit(SET_PASSWORD, data);
      return data;
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    JwtService.saveToken(state.user.Token);
  },
  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
  }
};
export default {state, actions, mutations, getters}

